import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Layout from "../Layout";
import RegistrationForm from "../RegistrationForm";
import NewGallery from "../../components/NewGallery";
import LoginForm from "../../components/LoginForm";
import styles from "./Dashboard.module.scss";
import Account from "../Account";
import GalleryDetail from "../GalleryDetail";
import EditGalleryForm from "../EditGalleryForm";
import ManageTacs from "../ManageTacs";
import ResetPassword from "../ResetPassword";
import ChangePassword from "../ChangePassword";
import Invite from "../Invite";
import CoHosts from "../CoHosts";

import World from "../../world";

type Props = {
    world: World;
    stripe_pub_key: string;
    uploads_base_url: string;
};

const Dashboard = (props: Props) => {
    const [authenticated, setAuthenticated] = useState(false);
    const [galleryName, setGalleryName] = useState('');
    const router = useRouter();
    const path = router.asPath.replace(/\?.*/, "")

    const onLoginSuccess = () => {
        if (_.size(props.world.galleries) === 0) {
            router.push("/dashboard/[[...all]]", "/dashboard/new-gallery");
        } else {
            router.push("/dashboard/[[...all]]", "/dashboard");
        }
        setAuthenticated(true);
    }

    const onLogout = async () => {
        setAuthenticated(false);
        props.world.logout();
    }

    // This is to fix the dev env. For some reason if the authenticated state
    // is set to true immediately then the HTML is a jumble of different
    // components.
    // TODO this causes the login screen to flash.
    useEffect(() => {
        if (window.localStorage.auth) {
            onLoginSuccess();
        }
    }, []);

    // This is to get the actual name of the gallery. When cohosts log in the
    // galllery name using their host ID is not the actual gallery name, so we
    // have to fetch the gallery using that as the initial name and then the
    // API will return the gallery with the correct name. Subcomponents of the
    // dashboard break for cohosts without this.
    useEffect(() => {

	    const rx = new RegExp(/^\/dashboard\/galleries\/(\d+)/);
	    const matches = rx.exec(path);

		if (!matches) {
			return;
		}
		if (!matches[1]) {
			return;
		}
		if (!props.world.host) {
			return;
		}
	    const galName = (`hosts/${props.world.host.id()}/galleries/${matches[1]}`);

	    // galleryName will be set if you've visited another, possibly
	    // different, gallery
	    if (galleryName && (galleryName == galName)) {
		    return;
	    }
	    (async function() {
		    const [name, err] = await props.world.getGallery(galName);
		    if (err) {
			    console.log(err);
			    return;
		    }
		    setGalleryName(name);
	    }())
    });

    if (!authenticated) {
        if (typeof window === "undefined") {
            return (
                <Layout classes={[styles.dashboard]}>
                    <LoginForm world={props.world} onLoginSuccess={onLoginSuccess}/>
                </Layout>
            );
        }
        switch(path) {
        case "/dashboard/create-account":
            return (
                <Layout classes={[styles.dashboard]}>
                    <RegistrationForm world={props.world} onSuccess={onLoginSuccess} />
                </Layout>
            );
        case "/dashboard/reset-password":
            return (
                <Layout classes={[styles.dashboard]}>
                    <ResetPassword world={props.world} />
                </Layout>
            );
        case "/dashboard/change-password":
            return (
                <Layout classes={[styles.dashboard]}>
                    <ChangePassword world={props.world} />
                </Layout>
            );
        default:
            return (
                <Layout classes={[styles.dashboard]}>
                    <LoginForm world={props.world} onLoginSuccess={onLoginSuccess}/>
                </Layout>
            );
        }
    }

    switch (path) {
    case "/dashboard":
    case "/dashboard/":
    case "/dashboard/index.html":
        return (
            <Layout classes={[styles.dashboard]}>
                <Account host={props.world.host} world={props.world} onLogout={onLogout}/>
            </Layout>
        );
    case "/dashboard/new-gallery":
        return (
            <Layout classes={[styles.dashboard]}>
                <NewGallery world={props.world} stripePubKey={props.stripe_pub_key} />
            </Layout>
        );
    default:
        if (galleryName) {
            if (_.endsWith(path, "edit")) {
                return (
                    <Layout classes={[styles.dashboard]}>
                        <EditGalleryForm world={props.world} name={galleryName} />
                    </Layout>
                );
            }
            if (_.endsWith(path, "tacs")) {
                return (
                    <Layout classes={[styles.dashboard]}>
                        <ManageTacs world={props.world} gallery_name={galleryName} />
                    </Layout>
                );
            }
            if (_.endsWith(path, "invite")) {
                return (
                    <Layout classes={[styles.dashboard]}>
                        <Invite world={props.world} gallery_name={galleryName} />
                    </Layout>
                );
            }
            if(_.endsWith(path, "cohosts")) {
                return (
                    <Layout classes={[styles.dashboard]}>
                        <CoHosts world={props.world} gallery_name={galleryName} />
                    </Layout>
                );
            }


            return (
                <Layout classes={[styles.dashboard]}>
                    <GalleryDetail world={props.world} name={galleryName} />
                </Layout>
            );
        }

        return (
            <Layout classes={[styles.dashboard]}>
                <Account host={props.world.host} world={props.world} onLogout={onLogout}/>
            </Layout>
        );
    }
}

export default Dashboard;
